import { defineStore } from "pinia";
import { SiteCallState } from "@/types/sse-types";

export const useDearborn = defineStore("dearborn", {
    state: (): SiteCallState => ({
        emergencyCalls: [],
        nonEmergencyCalls: [],
        displayLimit: 10,
        playAlertAudio: false
    }),
    actions: {},
    getters: {
        getDearbornEmergencyCalls: (state) => state.emergencyCalls.sort((a, b) => (a.event_ts < b.event_ts) ? 1 : -1),
        getDearbornNonEmergencyCalls: (state) => state.nonEmergencyCalls.sort((a, b) => (a.event_ts < b.event_ts) ? 1 : -1)
    }
})